import userImage0 from '../images/tv-feedback-user/0.jpg'
import userImage1 from '../images/tv-feedback-user/1.jpg'
import userImage2 from '../images/tv-feedback-user/2.jpg'
import userImage3 from '../images/tv-feedback-user/3.jpg'
import userImage4 from '../images/tv-feedback-user/4.jpg'
import userImage5 from '../images/tv-feedback-user/5.jpg'
import userImage6 from '../images/tv-feedback-user/6.jpg'
import userImage7 from '../images/tv-feedback-user/7.jpg'
import userImage8 from '../images/tv-feedback-user/8.jpg'
import userImage9 from '../images/tv-feedback-user/9.jpg'
import userImage10 from '../images/tv-feedback-user/10.jpg'
import userImage11 from '../images/tv-feedback-user/11.jpg'
import userImage12 from '../images/tv-feedback-user/12.jpg'
import userImage13 from '../images/tv-feedback-user/13.jpg'
import userImage14 from '../images/tv-feedback-user/14.jpg'
import userImage15 from '../images/tv-feedback-user/15.jpg'
import userImage16 from '../images/tv-feedback-user/16.jpg'
import userImage17 from '../images/tv-feedback-user/17.jpg'
import userImage18 from '../images/tv-feedback-user/18.jpg'
import userImage19 from '../images/tv-feedback-user/19.jpg'
import userImage20 from '../images/tv-feedback-user/20.jpg'
import userImage21 from '../images/tv-feedback-user/21.jpg'
import userImage22 from '../images/tv-feedback-user/22.jpg'
import userImage23 from '../images/tv-feedback-user/23.jpg'
import userImage24 from '../images/tv-feedback-user/24.jpg'
import userImage25 from '../images/tv-feedback-user/25.jpg'
import userImage26 from '../images/tv-feedback-user/26.jpg'
import userImage27 from '../images/tv-feedback-user/27.jpg'
import userImage28 from '../images/tv-feedback-user/28.jpg'
import userImage29 from '../images/tv-feedback-user/29.jpg'
import userImage30 from '../images/tv-feedback-user/30.jpg'
import userImage31 from '../images/tv-feedback-user/31.jpg'
import userImage32 from '../images/tv-feedback-user/32.jpg'
import userImage33 from '../images/tv-feedback-user/33.jpg'
let feedbackReason = [
  {
    title: "好きなタイミングで見れるのが最高です♪",
    userImage: userImage0,
    userMsg: "みさママさん (30代女性)<br/>フランス在住歴3年<br/>利用環境：自宅テレビ",
    msg: "KaitekiTVを利用し始めて1年になります。<br/>毎朝お弁当をつくって、子供を学校に送ったら私の時間☆彡<br/>ちょっと一休みしながら、見たかったドラマを楽しんでます。<br/>子供が帰ってくると好きなお笑いの番組を見て、主人は子供が寝た後にひっそりとビール飲みながらスポーツを見ています。<br/>4週間も遡れるから、その時間に見ようと焦る必要もないし、本当に最高です♪"
  },
  {
    title: "渋滞もストレスフリーに",
    userImage: userImage1,
    userMsg: "Yusakuさん (40代男性)<br/>インドネシア在住歴2年<br/>利用環境：タブレット",
    msg: "ジャカルタは世界一の渋滞といわれるほど毎日ひどい渋滞。ジャカルタの自宅から、郊外の工業団地まで出社に片道2時間はかかります。<br/>以前はポケモンGOなどをやって時間を潰していたのですが、KaitekiTVに出会って状況は一変。<br/>好きなバラエティ番組やゴルフ中継などを観ていると、気づいたら会社に着いているなんてことも。<br/>渋滞が全く苦でなくなったので、本当に有難いです！"
  },
  {
    title: "同僚に紹介したら、みんな感激",
    userImage: userImage2,
    userMsg: "禅さん (40代男性)<br/>ベトナム在住歴7年<br/>利用環境：Galaxy S9",
    msg: "自宅で楽しめるのはもちろんですが、出張先などでもすぐ日本の番組が視聴できるのでとても重宝しています。<br/>4週間前までの番組が全部見れますし、なんなら日本にいるより便利ですよね。<br/>私の紹介で同僚も契約しましたし、今後も利用していきたいと思います。"
  },
  {
    title: "その名の通り快適！",
    userImage: userImage3,
    userMsg: "D.Fさん (60代男性)<br/>アメリカ在住歴17年<br/>利用環境：サムソンのスマートフォン",
    msg: "以前使っていた他社サービスが、広告や宣伝が多く煩わしく、Kaiteki TVに変えました。<br/>以前のものより画質もよく、広告なども全くないので非常に満足しています。<br/>機能が多い分操作方法に慣れるのに少し時間がかかりましたが、慣れてしまえばもう手放せません。"
  },
  {
    title: "海外にいることを忘れそう・・",
    userImage: userImage4,
    userMsg: "艶美 さん (30代女性)<br/>アメリカ在住歴2年<br/>利用環境：スマホ",
    msg: "海外にいながら、日本のニュースや流行に乗り遅れることなく生活できます。<br/>4週間遡って視聴できるのは、日本でも使いたいぐらい便利で重宝しています。<br/>本当に便利な世の中になりましたよね。"
  },
  {
    title: "子供の友達がよく遊びにくるように！",
    userImage: userImage5,
    userMsg: "マーライオンさん(30代女性)<br/>シンガポール在住歴1年強<br/>利用環境：自宅TV",
    msg: "せっかくの初海外生活！<br/>子供の英語力を伸ばそうと少し無理して、インターナショナルスクールに通わせたんです。<br/>ただ、日本人のお友達がなかなか出来ず、本人もちょっと悩んでしまって。。。<br/>そんな時、たまたま知り合いのママさんにKaiteki TVのことを話したら、お子さん連れて見に来てくれて、そこからいろんな友達が遊びに来てくれるようになり、子供も大喜び！<br/>Kaiteki TVを契約して本当に良かったです！"
  },
  {
    title: "利用しての感想",
    userImage: userImage6,
    userMsg: "Junさん (50代男性)<br/>タイ在住歴23年<br/>利用環境：自宅TV",
    msg: "良い点<br/>止まらない。過去の番組が好きな時に観れる。<br/>改善点<br/>リモコンをもっと見やすく使いやすいサイズにして欲しい。"
  },
  {
    title: "毎日日本のテレビがある生活",
    userImage: userImage7,
    userMsg: "Winnie the Poohさん (30代女性)<br/>カナダ在住歴4年<br/>利用環境：自宅TV、タブレットPC",
    msg: "朝はニュース、昼はワイドショー、夜はドラマと我が家はずっとテレビつけっぱなしw<br/>旅行先でもちょっとした待ち時間でも、すぐに視聴できるのはホントに便利ですよー！<br/>新しいタブレットを買った時も、カスタマーサービスのスタッフが丁寧に対応してくれ<br/>て、本当に安心して使えるサービスで感謝しています！！<br/>いつまでカナダにいるか分かりませんが、帰国するその日までずっと利用したいと思います！"
  },
  {
    title: "戻ってきました！",
    userImage: userImage8,
    userMsg: "Y.Mさん (20代女性)<br/>イギリス在住歴3年<br/>利用環境： タブレット",
    msg: "ごめんなさい！来た当初はKaitekiTVさんを利用していたのですが、さらに料金の安い他社さんに1年間浮気してしまいました・・・。<br/>ただ、他社さんのサービスはすぐ映像は止まるし、音声が消えたりズレたりとストレスが溜まっていき、連絡をしてもなかなか繋がらない状況だったので、早々に更新をしないこと決め、KaitekiTVさんに戻ってきました！<br/>止まらないのはもちろんながら、今見ている番組を再生しながら他の番組を探せたり、<br/>スマホ、タブレット、ミラーリングなどいろんなデバイスに対応しているのは、もうさすがKaitekiTVさんです！<br/>カスタマーサービスも安心の日本語対応で、完全にストレスフリーです！<br/>少しの料金の違いに惹かれて浮気しちゃいましたが、これからは一途にいきます！"
  },
  {
    title: "韓国はソウルより",
    userImage: userImage9,
    userMsg: "カンジャンケジャン大好きさん (40代男性)<br/>韓国在住歴2年<br/>利用環境： テレビ",
    msg: "とても快適に日本のテレビを視聴できています。<br/>また、1ヶ月遡って過去番組が観れるのは、外出が多い私にとって非常に有難い機能で、<br/>LIVE放送を見ることはほとんど無くなってしまいました。<br/>家に帰ってTVをつけて、冷えたビール片手にスポーツ中継を見るのが、私の大事なルーティンになっています。"
  },
  {
    title: "ひきこもりのお供",
    userImage: userImage10,
    userMsg: "J.Yさん (30代男性)<br/>ドイツ在住歴20年以上<br/>利用環境： テレビ",
    msg: "もう6年もドュッセルドルフに住んでいますが、こんなにも外出しない日々が続いたのは初めてで、かなりヒマを持て余していました。<br/>唯一救いだったのは、KaitekiTVを契約していたこと。<br/>今までは数時間しか見なかったのですが、連日10時間以上は見ていました。<br/>それでも飽きることなく、ロックダウン期間を過ごすことができました。<br/>まだまだ感染拡大が大きい国など、まだまだ外出自粛が続いている国も多いと思いますが、<br/>これさえあれば、勝手に時間が過ぎていきますよ。<br/>みなさん大変な時期ですが、頑張って乗り切りましょう！"
  },
  {
    title: "安心して使えます。",
    userImage: userImage11,
    userMsg: "心の風 さん (20代男性)<br/>中国在住歴23年<br/>利用環境：スマートフォンとタブレット",
    msg: "以前他社さんでトラブルがあったので、レビューや評判などを比べKaiteki TVさんにしました！<br/>契約前はちゃんと視聴できるのか正直不安でしたが、こちらからの質問にもご丁寧にお答えいただき、契約後も全く問題なく視聴する事ができています。<br/>チャンネル数や画質も非常に満足で、もっと早くKaiteki TVさんにすればよかったです。<br/>これからも安定した番組配信をよろしくお願いいたします。"
  },
  {
    title: "期待以上",
    userImage: userImage12,
    userMsg: "豪州男 さん (30代男性)<br/>オーストラリア在住歴1年半<br/>利用環境：Fire TV Stick / Lenovo Tab M8",
    msg: "メリット<br/>いろんなデバイスを複数台接続可能<br/>日本の番組がすぐ観れる<br/>映画がすべて日本語字幕<br/>対応がとても早い<br/>デメリット<br/>たまに画面が止まる(ネット速度？)"
  },
  {
    title: "いつでも遡って見れる機能はとても便利！",
    userImage: userImage13,
    userMsg: "山下 さん (30代男性)<br/>アメリカ在住歴1年半<br/>利用環境：テレビ、タブレット端末、スマホ",
    msg: "アメリカは日本と時差が大きいので、見たい番組が仕事の時間と重なってしまうこともしばしば。<br/>なので、好きな時に好きな番組を見れる機能をとても重宝しています。<br/>今まで野球の試合を、結果だけネットで確認してということも多かったのですが、<br/>今は何も情報をいれずに家に帰って、ビール飲みながら楽しんでいます！<br/>本当に便利です"
  },
  {
    title: "家中どこでもいつでも日本のテレビ",
    userMsg:"Nana さん (30代女性)<br/>シンガポール在住歴2年<br/>利用環境：Galaxy Tab",
    msg: "主人の駐在に帯同してシンガポールにきてもうすぐ2年になります。<br/>来た当初から、Kaiteki TVを利用しています。<br/>キッチンで料理中にTVを観たり、お風呂でドラマを見ながらリラックスしたりしています！",
    userImage: userImage14
  },
  {
    title: "信頼できるサービスです",
    userImage: userImage15,
    userMsg: "芝刈ゴルファー さん (40代男性)<br/>マレーシア在住歴3年<br/>利用環境：TVとタブレット",
    msg: "他業者からKaiteki TVに乗り換えて１年が経ちました。<br/>以前の業者は電話は出ないし、折り返しもないことがほとんど、見れなくなってもインターネットの問題じゃないですかの一点張り。<br/>それなのに、支払いの時だけきっちり支払期限に電話してくる最悪な業者でした。<br/>そこでKaiteki TVさんに乗り換えたのですが、電話も出てくれるし、いつでも親切に回答くれます。視聴に問題がある時に、私だけなのか全体の問題なのかそれが分かるだけでも安心します。<br/>もちろん画質や支払いに関しても、全く問題ありません。<br/>これからもお願いいたします。"
  },
  {
    title: "日本のアニメがいっぱい見られる！",
    userImage: userImage16,
    userMsg: "Natasya さん (20代女性)<br/>インドネシア在住歴25年<br/>利用環境：スマートフォン",
    msg: "初めまして、日本が大好きなNatasyaといいます。<br/>私は日本のアニメが大好きです。とても素晴らしいです！<br/>コナン、ワンピース、Narutoみんな大好きです！<br/>インドネシアで日本のアニメはとても人気ですが、見ることできるのはWakuWakuチャンネルだけでした。<br/>でも、Kaiteki TVだともっとたくさん見ることができます。<br/>それがすごくすごく嬉しいです！<br/>また、日本に行きたいです。"
  },
  {
    title: "すごく便利なサービス",
    userImage: userImage17,
    userMsg: "Kobayashi さん (40代男性)<br/>ベトナム在住歴7年<br/>利用環境：自宅テレビ",
    msg: "いい点<br/>・契約も操作も簡単<br/>・画質が綺麗<br/>・日本語対応<br/>改善してほしい点<br/>・CMを飛ばす機能が欲しい<br/>宜しくお願いいたします。"
  },
  {
    title: "週末テレビ生活",
    userImage: userImage18,
    userMsg: "H.K さん (20代男性)<br/>タイ在住歴1年<br/>利用環境：テレビ",
    msg: "平日は仕事が忙しいので、土日に1週間分まとめて見ています。<br/>4週間遡れるのでその日に見なくちゃいけないというのがなく、本当に有難い機能ですね。<br/>これからもお世話になります。"
  },
  {
    title: "時差関係ないのがいいところ",
    userImage: userImage19,
    userMsg: "英国紳士 さん (40代男性)<br/>イギリス在住歴6年<br/>利用環境：NECのタブレット",
    msg: "日本と9時間時差があるので、見たい番組はだいたい仕事中。<br/>でも、好きな時間に見れる機能のおかげで見たい番組が全部見れます。<br/>すごく便利で助かっています。<br/>申込から利用まで、トラブル対応、支払対応まで全部スムーズで、<br/>何の不自由も感じておりません。<br/>これからも継続して利用させていただきます。"
  },
  {
    title: "サッカーより野球！",
    userImage: userImage20,
    userMsg: "ON さん (50代男性)<br/>タイ在住歴7年<br/>利用環境：タブレット",
    msg: "タイのテレビは正直あまり面白くありません。<br/>たまに見るとしても、サッカー好きの子供に付き合ってタイのサッカーリーグを見るぐらいでした。<br/>ただ、根っからの野球少年である私は、どうしても野球が見たいと思っていました。<br/>Kaiteki TVを契約したいまは、J-Sportsなどで日本のプロ野球中継を思う存分楽しんでいます。<br/>もう手放せません！"
  },
  {
    title: "時代の進化の恩恵を受けてます",
    userImage: userImage21,
    userMsg: "ロンリーチャップリン さん (50代男性)<br/>ブラジル在住歴3年<br/>利用環境：自宅TV",
    msg: "今回ブラジルへ2回目の駐在となるんですが、前回は10年以上前。<br/>日本のTVがこんなにも簡単に見れる時代になるなんて、その時は想像もしませんでした。<br/>KAITEKI TVのその便利さに驚いています。<br/>本当に有難うございます。"
  },
  {
    title: "アニメが大好きです！",
    userImage: userImage22,
    userMsg: "ハンコックLOVE さん (20代女性)<br/>台湾在住歴21年<br/>利用環境：タブレットとスマートフォン",
    msg: "日本のアニメが大好きでいつも見ています。<br/>日本のアニメは、絵も音楽も声優さんもすべてが一番だと思います！<br/>本当にすごいです！<br/>学校でも日本語のコースを選んでいるので、学校とテレビで日本語を勉強しています。<br/>KaitekiTVさんありがとうございます。"
  },
  {
    title: "日本のテレビが観れる幸せ",
    userImage: userImage23,
    userMsg: "M.Sさん (30代女性)<br/>ニュージーランド在住歴4年<br/>利用環境：テレビ/タブレット/スマホ",
    msg: "都市からちょっと離れた地域に住んでることもあって、正直楽しみが少ない毎日。<br/>子供たちは近所の子と公園で遊んだり、Youtube見たりしてるんですが、<br/>私はやっぱりテレビ世代！<br/>KaitekiTVを契約してから、娯楽の一番目が日本ドラマ鑑賞になりました！<br/>あまり良くないと思いつつ、毎日数時間見てしまっています。<br/>これからも宜しくお願いします！"
  },
  {
    title: "1ヶ月使ってみての感想",
    userImage: userImage24,
    userMsg: "H.Y さん (40代男性)<br/>ドイツ在住歴1年<br/>利用環境：TV版",
    msg: "Kaiteki TVと契約して1ヶ月ちょっと経ちました。<br/>最初は少し心配していましたが、ほとんど止まることなく毎日見れています。<br/>画質も綺麗で、全く問題ありません。<br/>ただ、4週間も遡って見れる便利さに慣れてしまって、リアルタイムで見ることがほぼ無くなってしまいました…。<br/>日本に戻ったら、これが出来なくなると思うとどうしようという贅沢な悩みが唯一の懸念点です。"
  },
  {
    title: "日本となんら変わりない環境",
    userImage: userImage25,
    userMsg: "グロリアさん (50代男性)<br/>フィリピン在住歴4年半<br/>利用環境：テレビ、携帯電話",
    msg: "契約してから今日まで、とても快適に視聴できています。<br/>チャンネル数も多いですし、過去の番組も見れますし、<br/>日本人スタッフの方の対応も非常に丁寧で、お勧めできるサービスです。"
  },
  {
    title: "海外移住者は必需品！",
    userImage: userImage26,
    userMsg: "aikoさん (40代女性)<br/>イタリア在住歴3年<br/>利用環境：タブレット、テレビ",
    msg: "元々イタリアのテレビしか見れなかった我が家。<br/>旦那は元々サッカーをやっていたので、イタリアのサッカーをよく見ていました。<br/>子供も言葉があまり分からないながらに、よく分からないアニメ？みたいなものを見ていました。<br/>でも、私は何を見てもちんぷんかんぷんで何も楽しくない！<br/>私だけが不満を募らせてたのですが、インターネットで探してKaiteki TVさんにたどり着きました。<br/>あまり乗り気でなかった主人も、私のあまりの圧に押されたようで（笑）、契約手続き等を私が全てやるという条件でやっと同意してくれました。<br/>契約手続きはすごく簡単！<br/>日本人スタッフの方にサポートもしていただいて、あっという間に完了！<br/>今となっては旦那はJ SPORTS、子供はディズニーやバラエティ、私はドラマとワイドショーと時間さえあればテレビを見ています♪<br/>イタリアのTV契約は止めちゃいました。笑<br/>これからもKaiteki TVさんにお世話になります！"
  },
  {
    title: "ネットさえあれば",
    userImage: userImage27,
    userMsg: "Kenta さん (30代男性)<br/>メキシコ在住歴3年<br/>利用環境：タブレット",
    msg: "ネットさえあれば、過去のものも現在のものもすぐに見れます。<br/>こんな便利なものがあるとは思いませんでした。<br/>海外移住の際は、活用した方がいいですよ！"
  },
  {
    title: "生活の一部になってます！",
    userImage: userImage28,
    userMsg: "Nanako さん (20代女性)<br/>ロシア在住歴9ヶ月<br/>利用環境：タブレット",
    msg: "来たばかり時は、YoutubeとNetflixで楽しめていましたが、やはりバラエティなんかも見たいなと思いKaiteki TVさんを契約しました。<br/>仕事柄、急に外出しなくちゃいけないことも多いんですが、過去に戻って見れるので<br/>本当に重宝しています。<br/>もはや生活の一部になってます！"
  },
  {
    title: "オススメです！",
    userImage: userImage29,
    userMsg: "ゆん♡ さん (30代女性)<br/>オーストラリア在住歴8年<br/>利用環境：テレビとタブレット",
    msg: "このサービスのいいところは、日本では見ていなかったようなチャンネルの1ヵ月前からとうかなり多い選択肢の中から好きに番組を選べること！<br/>以前は、他社のサービスを使っていたのですが、Kaiteki TVさんは安定性が全然違います！<br/>全くストレス感じることなく使えてます！<br/>日本人が対応してくれるというのも何かあったときに安心です！"
  },
  {
    title: "日本の人気者をちゃんとリサーチ",
    userImage: userImage30,
    userMsg: "Sachi7さん (40代女性)<br/>アメリカ在住歴17年<br/>利用環境：テレビ",
    msg: "日本のドラマや音楽番組、お笑い番組など毎日のように見ています。<br/>海外生活が長いと、どうしても帰国した際に友達との会話で？ってなることが多いのですが、どんな女優さんが人気で、どんな歌が流行っているか、Kaiteki TVで日々チェックしています♪<br/>ただ、一つだけ質問なんですが、音楽番組だけ少し画質が落ちるような気がします。<br/>他が綺麗すぎるので、贅沢な悩みと言えばそうなんですが、もし改善してもらえるようなら嬉しいです！<br/>これからも宜しくお願いします☆彡"
  },
  {
    title: "お世話になっております。",
    userImage: userImage31,
    userMsg: "M.Iさん (40代男性)<br/>ベルギー在住歴3年<br/>利用環境：テレビ",
    msg: "日本のテレビ放送はNHKワールドプレミアムしか見れないと諦めておりましたが、友人からKaiteki TVのことを聞いて契約しました。<br/>日本と全く変わらない番組数と画質に驚きました。<br/>非常に楽しく拝見させていただいています。"
  },
  {
    title: "すごく便利なサービス",
    userImage: userImage32,
    userMsg: "国士無双 さん (30代男性)<br/>中国在住歴4年<br/>利用環境：タブレット",
    msg: "中国にきて早4年。仕事の関係で、頻繁に海外出張しています。<br/>アジアはもちろんヨーロッパや南米いろいろ行きましたが、アフリカ以外はどこでも簡単に視聴できました。アフリカはネット環境最悪だったので、2週間どうしようもなかったです(泣)<br/>いつでもタブレットで好きな番組を視聴できるので、本当に重宝しています！！<br/>今はコロナの影響で出張もほぼないですが、在宅の時間が増え更に視聴時間が増えました！<br/>これからも末永いお付き合いをよろしくお願いします！"
  },
  {
    title: "ついにたどり着いた",
    userImage: userImage33,
    userMsg: "しがないエンジニア さん (30代男性)<br/>インド在住歴4年<br/>利用環境：自宅TV、タブレット",
    msg: "インドは駐在生活３カ国目になるのですが、今まで同じようなサービスをいくつか試してきました。<br/>頻繁に止まるものや、音ズレがひどいもの、不具合対応を全くしてくれない業者までありましたが、ようやくたどり着いたのがKaiteki TVさんです。<br/>まず、何より感動したのはその完成度の高さです。<br/>画質は綺麗だし、ほとんど止まることなく快適に観れます。<br/>操作方法も分かりやすく、日本人が使うのにも全く問題もないと感じています。<br/>それに、過去放送が４週間で自分の端末にダウンロードすることも可能！！<br/>見たかった番組を見逃すこともなければ、本当に気に入ったものは保存すればずっと観れちゃうんです！<br/>正直、日本にいるときよりずっと便利なテレビ環境です！<br/>本当にお勧めですよ！！"
  }
]
export default feedbackReason